import { Box, Button } from "theme-ui";

import * as styles from "./MagnificationButtons.styles";

export default function MagnificationButtons({
  zoomIn,
  zoomOut,
  zoomInDisabled,
  zoomOutDisabled,
  ...props
}) {
  return (
    <Box sx={styles.magnificationButtons} {...props}>
      <Button
        aria-label="zoom in"
        onClick={() => zoomIn()}
        disabled={zoomInDisabled}
        sx={styles.magnicationButton}
      >
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M1.5 5C0.947715 5 0.5 5.44772 0.5 6C0.5 6.55228 0.947715 7 1.5 7V5ZM10.5 7C11.0523 7 11.5 6.55228 11.5 6C11.5 5.44772 11.0523 5 10.5 5V7ZM7 1.5C7 0.947715 6.55228 0.5 6 0.5C5.44772 0.5 5 0.947715 5 1.5H7ZM5 10.5C5 11.0523 5.44772 11.5 6 11.5C6.55228 11.5 7 11.0523 7 10.5H5ZM1.5 7H10.5V5H1.5V7ZM5 1.5V10.5H7V1.5H5Z" />
        </svg>
      </Button>

      <Button
        aria-label="zoom out"
        onClick={() => zoomOut()}
        disabled={zoomOutDisabled}
        sx={styles.magnicationButton}
      >
        <svg
          width="12"
          height="2"
          viewBox="0 0 12 2"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M1.5 0C0.947715 0 0.5 0.447715 0.5 1C0.5 1.55228 0.947715 2 1.5 2V0ZM10.5 2C11.0523 2 11.5 1.55228 11.5 1C11.5 0.447715 11.0523 0 10.5 0V2ZM1.5 2H10.5V0H1.5V2Z" />
        </svg>
      </Button>
    </Box>
  );
}
